<template>
  <header
    class="bg-gray-25 absolute inset-0 flex h-50 items-center justify-between gap-20 border-b border-gray-200 px-20 shadow-sm"
  >
    <i class="bi-list text-24 hover:font-bold" @click="sidebarVisible = !sidebarVisible" />
    <div class="relative max-w-800 flex-auto max-sm:hidden">
      <div class="pointer-events-none absolute inset-0 flex items-center pl-15">
        <i class="bi-search text-16" />
      </div>
      <input
        v-model="search"
        class="border-input h-32 w-full rounded bg-white pr-10 pl-40"
        placeholder="Search schools..."
        @focus="
          isSearch = true;
          schoolStore.EnsureLoaded();
        "
        @blur="
          isSearch =
            ($event.relatedTarget as HTMLElement | null)?.getAttribute('name') ===
            'SchoolSearchItem'
        "
      />
      <div
        v-if="isSearch && SearchResults.length"
        class="border-input absolute inset-x-0 top-38 z-50 flex flex-col rounded bg-white"
      >
        <router-link
          v-for="result in SearchResults"
          :key="result.obj.SCH_School_PK"
          :to="`/schools/${result.obj.SCH_School_PK}`"
          name="SchoolSearchItem"
          class="flex items-center justify-start gap-15 border-b border-gray-100 p-15 first:rounded-t-sm last:rounded-b last:border-b-0 hover:bg-gray-50"
          @click="
            search = '';
            isSearch = false;
          "
        >
          <i class="bi-buildings text-20 font-thin" />
          <div class="min-w-0 flex-auto">
            <div
              class="text-14 truncate"
              v-text="result.obj.SCH_DisplayName || result.obj.SCH_Name"
            />
            <div
              class="text-12 truncate text-gray-600"
              v-text="`${result.obj.SCH_City || '—'} · ${result.obj.STA_Code || '—'}`"
            />
          </div>
        </router-link>
      </div>
    </div>
    <div class="group relative flex h-full items-center text-gray-700">
      <div class="flex-auto pr-10 text-right">
        <div class="text-14 max-w-160 truncate leading-[normal]" v-text="userStore.Email" />
        <div
          class="text-10 max-w-160 truncate leading-[normal] font-semibold uppercase"
          v-text="userStore.Directory"
        />
      </div>
      <app-avatar class="h-40 w-40" :name="userStore.Name" :uid="userStore.AAD_User_FK" />
      <div
        class="absolute top-49 right-0 z-50 hidden w-320 flex-col border border-r-0 border-gray-200 bg-gray-50 group-hover:flex"
      >
        <div class="flex h-50 items-center">
          <div class="flex-auto truncate pl-14" v-text="userStore.Directory" />
          <button
            class="h-full px-14 whitespace-nowrap hover:bg-gray-200 hover:underline"
            @click="SignOut"
            v-text="'Sign Out'"
          />
        </div>
        <div class="flex h-130 items-center gap-20 px-20">
          <app-avatar
            class="text-28 h-88 w-88"
            :name="userStore.Name"
            :uid="userStore.AAD_User_FK"
          />
          <div class="flex-auto">
            <div class="text-18 truncate font-bold" v-text="userStore.Name" />
            <div class="text-13 truncate" v-text="userStore.Email" />
            <a :href="AccountLink" class="link truncate" v-text="'View account'" />
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed, inject, ref, type Ref } from 'vue';
import { signOut, useUserStore } from '@/scripts/auth';
import { useSchoolIndexStore } from '@/stores/schoolIndex';
import AppAvatar from './Avatar.vue';
/// Setup
const userStore = useUserStore();
const schoolStore = useSchoolIndexStore();
const sidebarVisible = inject<Ref<boolean>>('sidebarVisible')!;
/// Data
const search = ref('');
const isSearch = ref(false);
/// Computed
const AccountLink = computed(
  () =>
    'https://myaccount.microsoft.com/?ref=MeControl&login_hint=' +
    encodeURIComponent(userStore.Email),
);
const SearchResults = computed(() => schoolStore.Search(search.value));
/// Methods
const SignOut = () => signOut();
</script>
